// Trust strip — sage band with four short trust claims, ported verbatim from
// the prototype's .trust markup.
export const TrustStrip = () => {
  return (
    <div className="trust">
      <div className="wrap">
        <span className="item">
          <span role="img" aria-label="pencil">
            ✎
          </span>{' '}
          Reads <b>handwriting</b> &amp; bubble (OMR)
        </span>
        <span className="item">
          <span role="img" aria-label="lightning bolt">
            ⚡
          </span>{' '}
          <b>Seconds</b> per sheet
        </span>
        <span className="item">
          <span role="img" aria-label="teacher">
            👩‍🏫
          </span>{' '}
          Built for <b>teachers</b>
        </span>
        <span className="item">
          <span role="img" aria-label="cloud">
            ☁
          </span>{' '}
          Every assessment <b>cloud-saved</b>
        </span>
      </div>
    </div>
  )
}
